import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from '@ntuctech/devex-tangram/Box';
import Tag from '@ntuctech/devex-tangram/Tag';
import SvgAccount from '@ntuctech/devex-tangram/Icon/SvgAccount';

const TagWrapper = styled(Box)`
  text-align: center;
  max-width: 100%;
  overflow: hidden;
`;

const StyledTag = styled(Tag)`
  &._ndsTag--contained._ndsTag--large {
    font-size: 1rem;
    line-height: 1.5rem;
    background-color: #f2f2f2;
    color: #333333;
    border: 0.0625rem solid #f2f2f2;
    padding: 0.25rem 0.5rem;
    max-width: 100%;
    overflow: hidden;
  }
  &._ndsTag--contained._ndsTag--large ._ndsTag__icon {
    fill: #333333;
    height: 1.5rem;
    width: 1.5rem;
  }
  & ._ndsTag__label {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
  }
`;

const UserTag = ({ content, ...rest }) => (
  <TagWrapper mb={2} {...rest} className="SSOPage__tag">
    <StyledTag label={content} variant="contained" size="l" color="grey" icon={<SvgAccount />} />
  </TagWrapper>
);

UserTag.propTypes = { content: PropTypes.string.isRequired };

export default UserTag;
